import Command from '@ckeditor/ckeditor5-core/src/command';
export default class InsertLinkCommand extends Command {

  execute(eventInfo, editingValue, ranges) {
    this.editor.fire('insertlink', eventInfo, editingValue, ranges);
    this.isEnabled = false;
    this.refresh();
  }

  refresh() {
    this.listenTo(this.editor.editing.view.document, 'click', () => { 
      if (this.editor.model.document.selection.getSelectedElement() === null) {
        this.isEnabled = true;
      } else {
        this.isEnabled = false;
      }
    });
  }
}

